import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
import { Button } from '../../../../design-system/button/button';

type ExpansionChevronIconButtonProps = {
  isExpanded: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const ExpansionChevronIconButton = ({ isExpanded, onClick }: ExpansionChevronIconButtonProps) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={(e) => {
        // Prevents the click from propagating to the parent row element
        e.stopPropagation();
        // table.getToggleAllRowsExpandedHandler requires the event to be passed in
        // See column definition file for more details
        onClick(e);
      }}
      className="h-4 w-4 shrink-0"
    >
      {isExpanded ? (
        <ChevronDownIcon className="h-full w-full text-muted-foreground" />
      ) : (
        <ChevronRightIcon className="h-full w-full text-muted-foreground" />
      )}
    </Button>
  );
};
